module.exports = __webpack_public_path__ + "img/img23.4c8644da.png";